var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"photo-wrapper"},[_c('img',{style:(_vm.renderStyle()),attrs:{"src":_vm.photoUrl}}),_c('figcaption',[_c('i',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.caption)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }